import { customElement } from '@aurelia/runtime-html';
import * as __au2ViewDef from './three-canvas.html';
import { KeyboardHandler } from 'resources/keyboard_handler';
import { GlobalDefinition } from 'resources/global_definitions';
import { InstanceUtility } from 'resources/services/instance_utility';
import { LineUpdateService } from 'resources/services/line_update_service';

@customElement(__au2ViewDef)
export class ThreeCanvas {

  // we inject here the keyboardHandler functions
  // do not delete
  constructor(
    private globalObjectInstance: GlobalDefinition,
    // do not delete
    private keyboardHandler: KeyboardHandler,
    private instanceUtility: InstanceUtility,
    private lineUpdateService: LineUpdateService

  ) {
  }

  attached() {
    //get html element by id
    const element = document.getElementById('container');
    this.globalObjectInstance.elementContainer = element;

    // set steady rendering at least every second
    //set intervall
    setInterval(async () => {
      this.globalObjectInstance.render = true;

      await this.checkForLineToUpdate();
    }, 1000);


  }

  async checkForLineToUpdate() {
    // for each relationclasInstance
    // get the relationclass instance from the tab context
    // and update the line if there is one
    let sceneInstance = await this.instanceUtility.getTabContextSceneInstance();
    if (sceneInstance?.relationclasses_instances.length > 0) {
      let uuid = sceneInstance.relationclasses_instances[0].uuid;

      let threeScene = await this.instanceUtility.getTabContextThreeInstance();
      // console.log('threeScene', threeScene);
      // console.log('uuid', uuid);
      let line = threeScene.getObjectByProperty('uuid', uuid);
      // console.log('line', line);
      line ? this.lineUpdateService.setPos(line) : null;
    }
  }
}



    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = ThreeCanvas;

    // @ts-ignore
    const proto = ThreeCanvas.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }